import { render, staticRenderFns } from "./TrainingModelProcess.vue?vue&type=template&id=64bbe7dd&scoped=true&"
import script from "./TrainingModelProcess.vue?vue&type=script&lang=js&"
export * from "./TrainingModelProcess.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModelProcess.vue?vue&type=style&index=0&id=64bbe7dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bbe7dd",
  null
  
)

export default component.exports